import React from 'react';
import LazyPageLoader from "../../components/LazyPageLoader.tsx";

const Page = React.lazy(()=>import('./EditImageRedirect'));

export default function LazyEditImageRedirect(){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}



